import React, { useEffect } from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import { useContactForm } from '../hooks/useContactForm'
import ToastContainer, { useToast } from './Toast'

const Contact = () => {
  const { ref, isVisible } = useScrollAnimation()
  const { formData, handleChange, handleSubmit, isSubmitting, submitStatus } = useContactForm()
  const { toasts, addToast, removeToast } = useToast()

  useEffect(() => {
    if (submitStatus === 'success') {
      addToast('Your message has been sent! We\'ll be in touch soon.', 'success')
    } else if (submitStatus === 'error') {
      addToast('Something went wrong. Please try again.', 'error')
    }
  }, [submitStatus, addToast])

  const contactInfo = [
    {
      icon: 'fas fa-location-dot',
      title: 'Visit Us',
      content: 'Mt Roskill, Auckland, New Zealand 1041'
    },
    {
      icon: 'fas fa-clock',
      title: 'Office Hours',
      content: 'Mon - Fri: 8:30am - 5:30pm'
    }
  ]

  return (
    <>
    <section id="contact" className="contact section" ref={ref}>
      <div className="container">
        <div className="section-header">
          <div className={`section-tag ${isVisible ? 'animate-fadeInUp' : ''}`}>
            Contact Us
          </div>
          <h2 className={`${isVisible ? 'animate-fadeInUp' : ''}`}>
            Let's Start a <span className="gradient-text">Conversation</span>
          </h2>
        </div>

        <div className="contact-content">
          {/* Contact Info */}
          <div className={`contact-info ${isVisible ? 'animate-slideInLeft' : ''}`}>
            {contactInfo.map((info, index) => (
              <div key={index} className="contact-item">
                <div className="contact-icon">
                  <i className={info.icon}></i>
                </div>
                <div className="contact-details">
                  <h4>{info.title}</h4>
                  <p>{info.content}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Contact Form */}
          <div className={`contact-form-wrapper ${isVisible ? 'animate-slideInRight' : ''}`}>
            <form className="contact-form" onSubmit={handleSubmit}>

              <div className="form-row">
                <div className="float-group">
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    placeholder=" "
                  />
                  <label htmlFor="firstName">First Name *</label>
                </div>
                <div className="float-group">
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    placeholder=" "
                  />
                  <label htmlFor="lastName">Last Name *</label>
                </div>
              </div>

              <div className="float-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder=" "
                />
                <label htmlFor="email">Email *</label>
              </div>

              <div className="float-group">
                <select
                  id="lookingFor"
                  name="lookingFor"
                  value={formData.lookingFor}
                  onChange={handleChange}
                  required
                  className={formData.lookingFor ? 'has-value' : ''}
                >
                  <option value=""></option>
                  <option value="hire-talent">Hire talent</option>
                  <option value="find-job">Find a job</option>
                  <option value="something-else">Something else</option>
                </select>
                <label htmlFor="lookingFor">I'm looking to... *</label>
              </div>

              <div className="float-group">
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder=" "
                ></textarea>
                <label htmlFor="message">Message *</label>
              </div>

              <button 
                type="submit" 
                className={`btn btn-primary btn-large ${isSubmitting ? 'submitting' : ''} ${submitStatus}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <div className="spinner"></div>
                    Sending...
                  </>
                ) : submitStatus === 'success' ? (
                  <>
                    <i className="fas fa-check"></i>
                    Message Sent!
                  </>
                ) : submitStatus === 'error' ? (
                  <>
                    <i className="fas fa-times"></i>
                    Error - Try Again
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane"></i>
                    Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
    <ToastContainer toasts={toasts} removeToast={removeToast} />
  </>
  )
}

export default Contact
